import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { AuthorService } from 'src/app/services/author.service';
import { ValidationService } from 'src/app/services/validation.service';
import { FileService } from 'src/app/services/file.service';
import { AlertController } from '@ionic/angular';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { ImageSceneAssetRelation } from 'src/app/models/scene-asset-relations/imageSceneAssetRelation';

@Component({
  selector: 'app-image-details',
  templateUrl: './image-details.component.html',
  styleUrls: ['./image-details.component.scss'],
})
export class ImageDetailsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;
  @Input('isFromMediaManagementPage') isFromMediaManagementPage: boolean = false;

  public imageFromMediaManagementPage: boolean = false;
  public oldAssetIDToCopy: number = -1;
  public imageSearchTerm: string;
  public searchNotFound: boolean = false;
  public keepAspectRatio:boolean = true;
  public previewMediaAsset:boolean = false;
  public imageSceneAssetRelation: ImageSceneAssetRelation;
  
  constructor(
    public authorService: AuthorService,
    public validationService: ValidationService,
    public assetTypeService: AssetTypeService,
    public alertController: AlertController,
  ) { }

  ngOnInit() {
    this.imageSceneAssetRelation = this.assetInScene.sceneAssetRelation as ImageSceneAssetRelation;    
  }    

  async selectFile() {
    let input = document.querySelector('#file-input');

    const alert = await this.alertController.create({
      header: 'Choose Media',
      message: 'You can browse for a file on your computer or select a file from the media management page.',
      cssClass: 'leave-alert quizard-alert',
      buttons: [{
        text: 'Add ' + this.assetType + ' from media management page',
        cssClass: '',
        handler: () => {
          this.currentStepInfo.addFromMediaManagementPage = true;
          this.oldAssetIDToCopy = this.currentStepInfo.uploadProperties.assetIDToCopy;
        }
      }, {
        text: 'Upload from computer',
        cssClass: '',
        handler:  () => {
          if (input) {
            input.click();
          }
        }
      }
      ]
    });
    await alert.present();
  }

  getAsset() {
    return this.authorService.selectedAsset.sceneAssetRelation as ImageSceneAssetRelation;
  }

  getImageAsset(): MediaAsset {
    return this.assetInScene.baseAsset as MediaAsset;
  }

  validateAssetName() {
    this.assetInScene.baseAsset.name = this.validationService.removeHtmlTags(this.assetInScene.baseAsset.name);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.setModalTransparency(1, e);
  }

  setModalTransparency(opacity, event) {
    if(!this.editing) return;
    var imageSettingsModal = document.getElementById('add-media-object-modal');
    imageSettingsModal.style.opacity = opacity;
  }

  updateXScale(event, asset) {
    asset.sceneAssetRelation.xScale = String(event.detail.value);
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  updateScaleChanged(event, asset) {
    this.updateScale(event.detail.value, asset)
  }

  imageAspectRatio() {
    this.keepAspectRatio = !this.keepAspectRatio;
    this.authorService.updateMediaAssetScale(this.assetInScene);
  }

  updateScale(xScale, asset){
    asset.sceneAssetRelation.xScale = String(xScale);    
    asset.sceneAssetRelation.yScale = Number(xScale) * asset.sceneAssetRelation.aspectRatioConstant;
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  updateYScale(event, asset) {
    asset.sceneAssetRelation.yScale = String(event.detail.value);
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  previewMedia(){
    this.previewMediaAsset = !this.previewMediaAsset;
  }

  validateBorderValue(event, asset: AssetInScene, minValue: number, maxValue: number) {
    var mediaSceneAssetRelation = asset.sceneAssetRelation as ImageSceneAssetRelation;
    var value: number = +event.target.value;
    value = this.validationService.validateMaxValue(value, maxValue);
    value = this.validationService.validateMinValue(value, minValue);
    mediaSceneAssetRelation.borderSize = value;
  }

  validateBorderColour(event, assetInScene: AssetInScene) {
    var mediaAsset = this.getAsset();
    if (mediaAsset.borderColour.trim().length == 0) {
      mediaAsset.borderColour = "#FFFFFF";
    }
  }

  onMediaAssetLoad(event) {
    let imageSceneAssetRelation = this.assetInScene.sceneAssetRelation as ImageSceneAssetRelation;
    let imageWidth: number = event.target.naturalWidth;
    let imageHeight: number = event.target.naturalHeight;
    imageSceneAssetRelation.aspectRatioConstant = imageWidth == 0 ? imageHeight : (imageHeight / imageWidth);

    if (imageSceneAssetRelation.keepAspectRatio === true) {
      this.authorService.updateMediaAssetScale(this.assetInScene);
    }
  }

}
